<template>
  <div>
    <c-box
      :title="'Позиции сайта в ПС ' + getSengineName(sengine) + ' по приоритетным запросам'"
      shadow
      header-divider
      :loading="loading"
    >
      <template v-slot:header-right>
        <form class="form-inline">
          <sengine-select
            v-model="sengine"
            small
            margin-bottom="0"
          />
        </form>
      </template>

      <table
        v-if="!loading && data.length && items.length"
        class="table"
      >
        <thead>
          <tr>
            <th>Запрос</th>
            <th>{{ from | moment('YYYY.MM.DD') }}</th>
            <th>{{ to | moment('YYYY.MM.DD') }}</th>
            <th>Динамика позиций за месяц</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in items"
            :key="item.ТекстЗапроса"
          >
            <td v-text="item.ТекстЗапроса" />
            <th v-text="item.ПозицияПрошлый" />
            <th v-text="item.ПозицияТекущий" />
            <th
              :class="{'text-success': item.ДинамикаЗаМесяц > 0}"
              v-text="(item.ДинамикаЗаМесяц > 0 ? '+' : '') + item.ДинамикаЗаМесяц"
            />
          </tr>
        </tbody>
      </table>
      <no-data v-if="!loading && (!data.length || !items.length)" />

      <div class="text-center margin-top hidden">
        <button class="btn background-white border-danger text-danger">
          Смотреть все позиции
        </button>
      </div>
    </c-box>

    <p
      v-if="conclusion"
      v-html="conclusionHtml"
    />
  </div>
</template>

<script>
import CBox from '../../../../../../../resources/js/components/ui/CBox.vue'
import sengine from '../../../../../../../resources/js/mixins/sengine'
import SengineSelect from '../SengineSelect'
import { conclusion1CToHtml } from '../../../../../../../resources/js/helper'
import NoData from '../../../../../../../resources/js/components/NoData.vue'
import { mapState } from 'vuex'

export default {
  name: 'PriorityDynamics',
  components: { NoData, SengineSelect, CBox },
  mixins: [sengine],
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    conclusion: {
      type: String,
      required: true
    },
    from: {
      type: String,
      required: true
    },
    to: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      sengine: this.$getConst('SENGINE_YANDEX')
    }
  },
  computed: {
    items () {
      return this.selectedRegion
        ? this
          .data
          .find(value => value.ПоисковаяСистема === this.getSengineName1C(this.sengine))
          .ТаблицаКатегорииТопа
          .filter(value => value.Регион === this.selectedRegion)
        : []
    },
    conclusionHtml () {
      return conclusion1CToHtml(this.conclusion)
    },
    ...mapState({
      selectedRegion: state => state.seo.client.projects.selectedRegion
    })
  }
}
</script>
